import { HttpParams } from '@angular/common/http';
import { ApiService } from '@libs/core/base-config';
import { omitUndefinedValues } from '@libs/core/lib/utils/utils';
import { Dtos, Entity, categoriesListResponseSchema, categorySchema } from '@libs/mtjr/shared/generated/types';
import { map } from 'rxjs';

export function categoriesList(apiService: ApiService, queryParams: Dtos.CategoriesListQueryParams) {
  const params = new HttpParams({ fromObject: omitUndefinedValues(queryParams) });
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/categories/categories-list`, { params })
    .pipe(map((data) => categoriesListResponseSchema().parse(data)));
}

export function categoryCreate(apiService: ApiService, { name }: Dtos.CategoryCreateBody) {
  return apiService.http
    .post(`${apiService.baseUrl}/api/v1/categories/category-create`, { name })
    .pipe(map((data) => categorySchema().parse(data)));
}

export function patchCategory(apiService: ApiService, id: string, categoryUpdate: Partial<Entity.CategoryUpdate>) {
  return apiService.http.patch<Dtos.UpdateResult>(`${apiService.baseUrl}/api/v1/categories/${id}`, categoryUpdate);
}

export function deleteCategory(apiService: ApiService, id: string) {
  return apiService.http.delete<void>(`${apiService.baseUrl}/api/v1/categories/${id}`);
}
